import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import {
    createVersionNote,
    updateVersionNote,
    CreateVersionNoteBody,
    UpdateVersionNoteBody,
    VersionNoteResponse,
} from '../../services/apiSLTP/versionNotes';

type UseCreateVersionNoteMutationOptions = MutationOptions<VersionNoteResponse, Error, CreateVersionNoteBody>;

type UseUpdateVersionNoteMutationOptions = MutationOptions<VersionNoteResponse, Error, { id: string; data: UpdateVersionNoteBody }>;

export const useCreateVersionNoteMutation = (options?: UseCreateVersionNoteMutationOptions) => {
    const mutationFn: MutationFunction<VersionNoteResponse, CreateVersionNoteBody> = async (data) => {
        return await createVersionNote(data);
    };

    return useMutation(mutationFn, options);
};

export const useUpdateVersionNoteMutation = (options?: UseUpdateVersionNoteMutationOptions) => {
    const mutationFn: MutationFunction<VersionNoteResponse, { id: string; data: UpdateVersionNoteBody }> = async ({ id, data }) => {
        return await updateVersionNote(id, data);
    };

    return useMutation(mutationFn, options);
};
